import React, { useState, useEffect, useRef } from "react";
import "../Employee/employee.css";
// import "./employee.css";
import "../button.css";
import RequestLeave from "../Employee/RequestLeave/RequestLeave";
import NotificationComponent from "../../NotificationCard";

// import StartIcon from "../../utilities/start.svg";
// import PauseIcon from "../../utilities/pause.svg";
// import ResumeIcon from "../../utilities/resume.svg";
// import StopIcon from "../../utilities/stop.svg";

import { Alert, Snackbar } from "@mui/material";
import AddEmployee from "./AddEmployee/addEmployee";
import Requests from "./Requests/requestedLeaves";
import PastTimers from "./pastTimers/pastTimers";
import ProgressReports from "./Show Progress Reports/progressReports";
import Profile from "./Profiles/profiles";
import Navbar from "../Navbar/navbar";
// import RunningTimers from "./currentTimers/timers";
// import RequestLeave from "./Request A Leave/RequestLeave";
// import Countdown from "./My Countdown/Countdown";

import "./hr.css";
import Sidebar from "./Sidebar/sidebar";
import Dashboard from "./Dashboard/Dashboard";
import Events from "./Events/Events";
import OtherProjects from "./Projects/OtherProjects";
import Projects from "./Projects/Projects";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TableContainer,
  TextField,
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Dialog,
} from "@mui/material";
import PersonalDetails from "../Employee/Personals/PersonalDetails";
import OfficialDocs from "./Official Docs/OfficialDocs";
import IdeasForm from "../Ideas Board/IdeasForm";
import IdeasDashboard from "../Ideas Board/IdeasDashboard";
import Attendance from "../Attendance/Attendance";
import ProjectShowcaseBrowse from "../ProjectShowcase/ProjectShowcaseBrowse";
import AttendanceEditor from "./AttendanceEditor/AttendanceEditor";

const Hr = (props) => {
  const user = props.user;
  const [Employee, setEmployee] = useState(null);
  const [lastInactive, setLastInactive] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isStopped, setIsStopped] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabled2, setisDisabled2] = useState(true);

  const timeoutRef = useRef(null);
  const [showMainReport, setShowMainReport] = useState(false);
  const [selectedProject, setselectedProject] = useState("");
  const [appointmentTaken, setAppointmentTaken] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [reportDetail, setreportDetail] = useState("");
  const [pipelineMoved, setPipelineMoved] = useState("");
  const [emailSent, setEmailSent] = useState("");
  let [timerCount, setTimerCount] = useState(0);
  const [messageLine, setMessageLine] = useState();
  const [messageToggle, setMessageToggle] = useState(false);
  const [myProfileToggle, setmyProfileToggle] = useState(false);
  const [docsToggle, setDocsToggle] = useState(false);
  const [ideasToggle, setIdeasToggle] = useState(false);
  const [attendanceToggle, setAttendanceToggle] = useState(false);

  const [dashbaordToggle, setDashbaordToggle] = useState(true);
  const [addEmployeeToggle, setAddEmployeeToggle] = useState(false);
  const [progressReportsToggle, setProgressReportsToggle] = useState(false);
  const [requestedLeavesToggle, setRequestedLeavesToggle] = useState(false);
  const [pastTimersToggle, setPastTimersToggle] = useState(false);
  const [projectsToggle, setProjectsToggle] = useState(false);
  const [employeeDetailsToggle, setEmployeeDetailsToggle] = useState(false);
  const [eventsToggle, setEventsToggle] = useState(false);
  const [myCountdownToggle, setMyCountdownToggle] = useState(false);
  const [requestALeaveToggle, setRequestALeaveToggle] = useState(false);
  const [projectShowcaseToggle, setProjectShowcaseToggle] = useState(false);
  const [attendanceEditorToggle, setAttendanceEditorToggle] = useState(false);
  const isExecutive = user.role === "Executive";

  useEffect(() => {
    //
    const loginEmployee = async () => {
      try {
        const response = await fetch(
          `https://hr-backend-72v1.onrender.com/loginemployee?email=${user.email}`
        );
        const data = await response.json();

        if (response.ok) {
          // console.log('Login successful:', data);
          setEmployee(data);
        } else {
          console.error("Login failed:");
        }
      } catch (error) {
        console.error("Error during login:");
      }
    };

    loginEmployee();
  }, [user.email]);

  useEffect(() => {
    if (myCountdownToggle) {
      setTimerCount(1);
    }
  }, [myCountdownToggle]);

  const dashbaordToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(true);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const handleOpenAddEmployee = () => {
    setAddEmployeeToggle(true);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const handleCloseAddEmployee = () => setAddEmployeeToggle(false);

  const progressReportsToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(true);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const requestedLeavesToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(true);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const pastTimersToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(true);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const projectsToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(true);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const employeeDetailsToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(true);
    setProgressReportsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const eventsToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setEventsToggle(true);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const myCountdownToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(true);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const requestALeaveToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(true);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };

  const docsToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(true);
    setIdeasToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const ideasToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(true);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };
  const attendanceToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(true);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };

  const profileToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(true);
    setDocsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(false);
  };

  const projectShowcaseToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(true);
    setAttendanceEditorToggle(false);
  };

  // HR-only "Edit Attendance" panel (Executives share this portal but must not see it).
  const attendanceEditorToggleHandler = () => {
    setAddEmployeeToggle(false);
    setRequestedLeavesToggle(false);
    setPastTimersToggle(false);
    setProjectsToggle(false);
    setEmployeeDetailsToggle(false);
    setProgressReportsToggle(false);
    setmyProfileToggle(false);
    setDocsToggle(false);
    setIdeasToggle(false);
    setDashbaordToggle(false);
    setEventsToggle(false);
    setMyCountdownToggle(false);
    setRequestALeaveToggle(false);
    setAttendanceToggle(false);
    setProjectShowcaseToggle(false);
    setAttendanceEditorToggle(true);
  };

  const handleEmployeeChange = (event) => {
    setEmployee(event.target.value);
  };

  const handleStopClick = () => {
    setOpenDialog(true);
  };
  const handleProjectDropChange = (event) => {
    setselectedProject(event.target.value);
  };
  const handleAppointmentTakenChange = (event) => {
    setAppointmentTaken(event.target.value);
  };

  const handleEmailSentChange = (event) => {
    setEmailSent(event.target.value);
  };
  const handlePipelineMovedChange = (event) => {
    setPipelineMoved(event.target.value);
  };
  const handleReportDetail = (event) => {
    setreportDetail(event.target.value);
  };

  const handleReportSubmit = async () => {
  try {
    let reportData;

    if (selectedProject === "MasterMind") {
      reportData = {
        name: user.name,
        email: user.email,
        appointmentsTaken: appointmentTaken,
        emailSent,
        pipelineMoved,
        date: new Date(),
      };

      const response = await fetch("https://hr-backend-72v1.onrender.com/projecta", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reportData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.text();
      // console.log('MasterMind Response:', responseData);
    } 
    
    else if (selectedProject === "Progress Report") {
      // ✅ Adjust to local timezone and convert to ISO string
      const now = new Date();
      const offset = now.getTimezoneOffset();
      const localTime = new Date(now.getTime() - offset * 60000);

      reportData = {
        name: user.name,
        email: user.email,
        reportDetail,
        date: localTime.toISOString(), // ✅ consistent timestamp with check-in/out
      };

      const response = await fetch("https://hr-backend-72v1.onrender.com/reports", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reportData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.text();
      // console.log('Progress Report Response:', responseData);
    }

    alert("Report Submitted Successfully");
    window.location.reload();

  } catch (error) {
    alert("There Was an Error Submitting Your Request");
    // console.error('Error submitting report:', error);
  }
};


  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmSubmit = async () => {
    const ok = await handleStop(); // only advance if the checkout actually succeeded
    setOpenDialog(false);
    if (ok) {
      setShowMainReport(true);
    }
  };

  useEffect(() => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      // Listener for messages from the service worker (optional for handling updates)
      const swListener = (event) => {
        if (
          event.data.type === "timerUpdate" &&
          event.data.email === user.email
        ) {
          setTime(event.data.time); // Update time based on the service worker's data
        }
      };

      // Add the listener for service worker messages
      navigator.serviceWorker.addEventListener("message", swListener);

      return () => {
        navigator.serviceWorker.removeEventListener("message", swListener);
      };
    }
  }, [user.email]);

  useEffect(() => {
    const fetchTimerRecord = async () => {
      try {
        const response = await fetch("https://hr-backend-72v1.onrender.com/get-timer-record", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: user.email }), // Send email in the request body
        });
        const data = await response.json();
        if (response.ok) {
          // Set the time and updatedAt values
          setTime(data.record.time); // Assuming your timer record has a 'time' field
          setLastInactive(data.record.updatedAt); // Set updatedAt value
        } else {
          setTime(0);
        }
      } catch (error) {
        setTime(0);
      }
    };
    if (myCountdownToggle && timerCount < 1) {
      fetchTimerRecord();
    }
  }, [user.email, myCountdownToggle]);
  useEffect(() => {
    if (lastInactive) {
      const formattedTime = formatTime(time);
      setAlertMessage(
        `You were inactive since ${new Date(
          lastInactive
        ).toLocaleString()}. Your timer is going to start from ${formattedTime} seconds.`
      );
      setShowAlert(true);
    }
  }, [lastInactive]);
  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  // useEffect(() => {
  //   if (isRunning && !isPaused) {
  //     console.log(`Timer is running: ${hours}h ${minutes}m ${seconds}s`);
  //   }
  // }, [time, isRunning, isPaused, hours, minutes, seconds]);

  // Send timer actions to the service worker
  useEffect(() => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      if (isRunning && !isPaused) {
        // Start the timer
        navigator.serviceWorker.controller.postMessage({
          action: "startTimer",
          name: user.name,
          email: user.email,
          time,
          isRunning: true,
          isPaused: false,
        });
      } else if (isPaused) {
        // Pause the timer
        navigator.serviceWorker.controller.postMessage({
          action: "pauseTimer",
          name: user.name,
          email: user.email,
          isRunning: isRunning,
          isPaused: true,
        });

        // Alert after 1 minute of being paused
        timeoutRef.current = setTimeout(() => {
          if (isPaused && !isStopped) {
            navigator.serviceWorker.controller.postMessage({
              action: "alert",
              email: user.email,
              message: "User has not resumed the timer after 1 minute",
            });
          }
        }, 60000);
      } else if (!isRunning && !isStopped) {
        // Resume the timer
        navigator.serviceWorker.controller.postMessage({
          action: "resumeTimer",
          name: user.name,
          email: user.email,
          isRunning: true,
          isPaused: false,
        });
      } else if (isStopped) {
        // Stop the timer
        navigator.serviceWorker.controller.postMessage({
          action: "stopTimer",
          name: user.name,
          email: user.email,
          isRunning: false,
          isPaused: true,
        });
      }
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isRunning, isPaused, isStopped, time, user.email]);

  const handleStart = async () => {
    console.log("Clicked.");
    setIsDisabled(true);
    setisDisabled2(false);
    let checker = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    });
    const checkerDate = new Date(new Date(checker).toISOString());
    const now = new Date();
    const offset = now.getTimezoneOffset(); // Get timezone offset in minutes
    const localTime = new Date(now.getTime() - offset * 60000);
    const timerData = {
      email: user.email,
      name: user.name,
      date: localTime.toISOString(),
      time: null,
      term: "checkin",
      checker: checkerDate,
    };
    // console.log(timerData);
    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/storeTimerData", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(timerData),
      });

      if (response.status === 401) {
        const data = await response.json().catch(() => ({}));
        setAlertMessage(data.message || "Your session expired. Please log in again.");
        setShowAlert(true);
        if (data.time) {
          // Business "already checked in" 401 carries the check-in time.
          setMessageLine(data.time);
          setMessageToggle(true);
          setisDisabled2(false);
        } else {
          // Auth 401 (no time) — don't render the time banner; re-enable Check In.
          setIsDisabled(false);
        }
        return;
      }
      if (response.status === 200) {
        setAlertMessage("Check In Successful");
        setMessageLine(localTime.toISOString());
        setMessageToggle(true);
        setisDisabled2(false);
        setShowAlert(true);
      }

      if (!response.ok) {
        console.error("Failed to store timer data");
      }
    } catch (error) {
      console.error("Error storing timer data:", error);
    }
  };

  // Pause the timer
  // const handlePause = () => {
  //   setIsPaused(true);
  //   if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  //     navigator.serviceWorker.controller.postMessage({
  //       action: 'pauseTimer',
  //       name: user.name,
  //       email: user.email,
  //       isRunning: isRunning,
  //       isPaused: true,
  //     });
  //   }
  // };

  // Resume the timer
  // const handleResume = () => {
  //   setIsPaused(false);
  //   setIsStopped(false);
  //   if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  //     navigator.serviceWorker.controller.postMessage({
  //       action: 'resumeTimer',
  //       name: user.name,
  //       email: user.email,
  //       isRunning: true,
  //       isPaused: false,
  //     });
  //   }
  //   clearTimeout(timeoutRef.current);
  // };

  // Stop the timer
  const handleStop = async () => {
    // NOTE: the on-screen timer is stopped only AFTER the server confirms the
    // checkout (below), so a failed request leaves the user cleanly checked in.
    const formattedTime = formatTime(time);
    let checker = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
    });
    const checkerDate = new Date(new Date(checker).toISOString());
    const now = new Date();
    const offset = now.getTimezoneOffset(); // Get timezone offset in minutes
    const localTime = new Date(now.getTime() - offset * 60000);
    const timerData = {
      email: user.email,
      name: user.name,
      date: null,
      time: localTime.toISOString(),
      term: "checkout",
      checker: checker,
    };

    try {
      const response = await fetch("https://hr-backend-72v1.onrender.com/storeTimerData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(timerData),
      });

      if (response.status === 201) {
        // Success: NOW stop the on-screen timer.
        setIsRunning(false);
        setIsPaused(false);
        setIsStopped(true);
        setAlertMessage("Check Out Successful");
        setShowAlert(true);
        return true;
      }

      // Not 201 (e.g. 401 session expired): keep the user checked in and say so.
      setAlertMessage(
        response.status === 401
          ? "Your session expired - please log in again to check out."
          : "Checkout failed - please try again."
      );
      setShowAlert(true);
      return false;
    } catch (error) {
      setAlertMessage("Checkout failed - please check your connection and try again.");
      setShowAlert(true);
      return false;
    }

    // if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    //   navigator.serviceWorker.controller.postMessage({
    //     action: 'stopTimer',
    //     name: user.name,
    //     email: user.email,
    //     isRunning: false,
    //     isPaused: false,
    //   });
    // }
    // const userMail = user.email;
    // deleteTimerRecord(userMail);
  };

  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, []);

  const beforeUnloadHandler = (event) => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.ready) {
      if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
        if (!isStopped) {
          navigator.serviceWorker.controller.postMessage({
            action: "pauseTimer",
            name: user.name,
            email: user.email,
            isRunning: isRunning,
            isPaused: true,
          });
        }
      }
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister().then((boolean) => {
          console.log(`Service worker unregistered: ${boolean}`);
        });
      });
    }
  };

  const formatTime = (time) => {
    if (typeof time !== "number" || isNaN(time)) {
      return "00:00:00";
    }
    return new Date(time * 1000).toISOString().substr(11, 8);
  };

  return (
    <div className="hr">
      <Sidebar
        user={user}
        onDashboard={dashbaordToggleHandler}
        onAddEmployee={handleOpenAddEmployee}
        onShowLeaves={requestedLeavesToggleHandler}
        onShowTimers={pastTimersToggleHandler}
        onShowProgress={progressReportsToggleHandler}
        onShowProjectA={projectsToggleHandler}
        onShowProfile={employeeDetailsToggleHandler}
        onShowEvents={eventsToggleHandler}
        onMyCountdown={myCountdownToggleHandler}
        onRequestALeave={requestALeaveToggleHandler}
        // onShowProfileOwn={profileToggleHandler}
        onShowDocs={docsToggleHandler}
        onShowIdeas={ideasToggleHandler}
        onShowAttendance={attendanceToggleHandler}
        onShowProjectShowcase={projectShowcaseToggleHandler}
        showProjectShowcase={isExecutive || user.role === "HR"}
        onShowAttendanceEditor={attendanceEditorToggleHandler}
        showAttendanceEditor={user.role === "HR"}

        dashbaordToggle={dashbaordToggle}
        addEmployeeToggle={addEmployeeToggle}
        progressReportsToggle={progressReportsToggle}
        requestedLeavesToggle={requestedLeavesToggle}
        pastTimersToggle={pastTimersToggle}
        projectsToggle={projectsToggle}
        employeeDetailsToggle={employeeDetailsToggle}
        eventsToggle={eventsToggle}
        myCountdownToggle={myCountdownToggle}
        requestALeaveToggle={requestALeaveToggle}
        // myProfileToggle={myProfileToggle}
        docsToggle={docsToggle}
        ideasToggle={ideasToggle}
        attendanceToggle={attendanceToggle}
        projectShowcaseToggle={projectShowcaseToggle}
        attendanceEditorToggle={attendanceEditorToggle}
      />

      {/* <NotificationComponent
          alertMessage={alertMessage}
          showAlert={showAlert}
          handleCloseAlert={handleCloseAlert}
        /> */}
      <Snackbar
        open={showAlert}
        autoHideDuration={15000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseAlert} severity="info">
          {alertMessage}
        </Alert>
      </Snackbar>

      <div className="content">
        <Navbar user={user} onShowProfileOwn={profileToggleHandler} />
        {dashbaordToggle && <Dashboard user={user} commandCenter onViewAllEmployees={employeeDetailsToggleHandler} />}
        {addEmployeeToggle && (
          <AddEmployee addEmployeeToggle={addEmployeeToggle} />
        )}
        {progressReportsToggle && (
          <ProgressReports progressReportsToggle={progressReportsToggle} />
        )}
        {requestedLeavesToggle && (
          <Requests requestedLeavesToggle={requestedLeavesToggle} user={user} />
        )}
        {pastTimersToggle && <PastTimers pastTimersToggle={pastTimersToggle} />}
        {projectsToggle && <Projects projectsToggle={projectsToggle} />}
        {employeeDetailsToggle && (
          <Profile user={user} employeeDetailsToggle={employeeDetailsToggle} />
        )}
        {eventsToggle && <Events user={user} />}
        {myCountdownToggle && (
          <div className="timer">
            <p>
              C H E C K<span className="countdown-space"></span>I N / C H E C K
              <span className="countdown-space"></span>O U T
            </p>
            {!showMainReport && (
              <>
                <div className="toggles">
                  <button
                    onClick={handleStart}
                    disabled={isDisabled}
                    className="start toggle-btns"
                  >
                    Check In
                    <span style={{ marginRight: "2px" }}></span>
                    <PlayArrowOutlinedIcon sx={{ fontSize: "xx-large" }} />
                  </button>
                  {/* <button onClick={handlePause} className="pause toggle-btns">
                Pause
                <img className="toggleImgs" src={PauseIcon} alt="Pause Icon" width="24" height="24" />
              </button>
              <button onClick={handleResume} className="resume toggle-btns">
                Resume
                <img className="toggleImgs" src={ResumeIcon} alt="Resume Icon" width="24" height="24" />
              </button> */}
                  <button
                    className="stop toggle-btns"
                    disabled={isDisabled2}
                    onClick={handleStopClick}
                  >
                    Check Out
                    <span style={{ marginRight: "10px" }}></span>
                    <LogoutIcon />
                    {/* <img className="toggleImgs" src={StopIcon} alt="Stop Icon" width="24" height="24" /> */}
                  </button>
                </div>
                {messageToggle && messageLine && !isNaN(new Date(messageLine).getTime()) && (
                  <div className="hours">
                    <p>Checked In At</p>
                    <div className="timer-blocks">
                      <p>
                        {
                          new Date(messageLine)
                            .toISOString()
                            .split("T")[1]
                            .split(".")[0]
                        }
                        <hr />
                        {new Date(messageLine).toISOString().split("T")[0]}
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
            {showMainReport && (
              <div className="main-report">
                <div className="submit-report-head">
                  <p>Submit Report</p>
                </div>

                {/* <div className="project-type">
                  <FormControl fullWidth>
                    <InputLabel id="progress-report-submission">
                      Mastermind / Progress Report
                    </InputLabel>
                    <Select
                      labelId="progress-report-submission"
                      id="progress"
                      value={selectedProject}
                      label="Mastermind / Progress Report"
                      onChange={handleProjectDropChange}
                    >
                      <MenuItem value="MasterMind">MasterMind</MenuItem>
                      <MenuItem value="Progress Report">
                        Progress Report
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div> */}

                {/* {selectedProject === "MasterMind" && (
                <div className="mastermind-submit">
                  <div className="appointments">
                    <TextField
                      margin="dense"
                      id="appointmentTaken"
                      label="Appointment Taken"
                      type="number"
                      fullWidth
                      value={appointmentTaken}
                      onChange={handleAppointmentTakenChange}
                    />
                  </div>
                  <div className="emailsent">
                    <FormControl fullWidth>
                      <InputLabel id="email-sent">Email Sent</InputLabel>
                      <Select
                        labelId="email-sent"
                        id="email-sent"
                        value={emailSent}
                        label="Email Sent"
                        onChange={handleEmailSentChange}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="pipelines">
                    <FormControl fullWidth>
                      <InputLabel id="pipeline-moved">
                        Pipeline Moved
                      </InputLabel>
                      <Select
                        labelId="pipeline-moved"
                        id="pipeline-moved"
                        value={pipelineMoved}
                        label="Pipeline Moved"
                        onChange={handlePipelineMovedChange}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              )} */}

                {/* {selectedProject === "Progress Report" && (
                  <div className="progress-report-submit">
                    <TextField
                      margin="dense"
                      id="reportdetail"
                      label="Report Detail"
                      type="text"
                      fullWidth
                      multiline
                      rows={4}
                      value={reportDetail}
                      onChange={handleReportDetail}
                      sx={{ flex: 1 }}
                    />
                  </div>
                )} */}

                <div className="progress-report-submit">
                  <TextField
                    margin="dense"
                    id="reportdetail"
                    label="Report Detail"
                    type="text"
                    fullWidth
                    multiline
                    rows={4}
                    value={reportDetail}
                    onChange={handleReportDetail}
                    sx={{ flex: 1 }}
                  />
                </div>
                <div className="report-submit">
                  <button className="submit-btn" onClick={handleReportSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {requestALeaveToggle && (
          <RequestLeave user={user} Employee={Employee} />
        )}
        {myProfileToggle && (
          <>
            {/* <h1 className="heading">Profile Section Coming Soon !</h1> */}
            <PersonalDetails
              user={user}
              Employee={Employee}
              changeEmployeeInfo={handleEmployeeChange}
            />
          </>
        )}
        {docsToggle && (
          <>
            {/* <h1 className="heading">Profile Section Coming Soon !</h1> */}
            <OfficialDocs
              user={user}
              Employee={Employee}
              // changeEmployeeInfo={handleEmployeeChange}
            />
          </>
        )}
        {ideasToggle && (
          <>
            {/* <IdeasForm user={user} /> */}
            <IdeasDashboard user={user} />
          </>
        )}
        {attendanceToggle && <Attendance user={user} />}
        {projectShowcaseToggle && <ProjectShowcaseBrowse user={user} />}
        {attendanceEditorToggle && user.role === "HR" && (
          <AttendanceEditor user={user} />
        )}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you ready to Submit Progress Report?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm if you're ready to submit the progress report.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              No
            </Button>
            <Button onClick={handleConfirmSubmit} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default Hr;
